import React, { useState, useEffect } from 'react';
import { Link,Navigate, useParams } from 'react-router-dom';
import Navbar from '../navbar/navbar';
import './grupo.css'
import { api } from '../../services/api';
import { vhostV1, vhostV2 } from '../funcoes';
import SweetAlert from 'react-bootstrap-sweetalert';
import customizeScrollbar from "customsb";
import FooterBar from '../footer/footerBar';
import SRI_pagination from '../components/pagination/pagination';
import BuscaVazaia from '../components/buscavazia/buscaVazia';
import GrupoProdutosPdf from '../reports/grupos/relGrupos';
import GrupoProdutosExcel from '../reports/grupos/relGruposExcel';




function SubGrupo() {

  const {tag} = useParams();

     const [texto,setTexto] = useState('');
     const [busca,setBusca] = useState("");
     const [grupos,setGrupos] = useState([]);
     const [cod_grupo,setCod_grupo] = useState(0);
     const [subGrupos,setSubGrupos] = useState([]);
     const [load,setLoad] = useState(false);
     const [nPag,setnPag] = useState(1);
     const [totalPaginas,setTotalPaginas] = useState(0); 
     const [tpBusca,setTpBusca] = useState(0);
    
     const [produtos,setProdutos] = useState([]);
     const [sResult,setSresult] = useState(0);
     const [erroValidacao, setErrovalidacao] = useState(false);
     const [msgErro, setmsgErro] = useState('') ;
     const [dCadastro,setDcadastro] = useState(new Date);
     const [dAlteracao,setDalteracao] = useState(new Date);
     const [dultCompra,setDultcompra] = useState(new Date);
     const [dultVenda,setDultvenda] = useState(new Date);

     const [usaDcadastro,setUsaDcadastro] = useState(false);
     const [usaDAlteracao,setusaDalteracao] = useState(false);
     const [usaDultCompra,setusaDultcompra] = useState(false);
     const [usaDultVenda,setusaDultvenda] = useState(false);


     const [cGrupo,setCgrupo] = useState(0);
     const [cSubGrupo,setCsubGrupo] = useState(0);
     const [cLinha,setClinha] = useState(0);


     const [diferenteZero,setDiferenteZero] = useState(false);
     const [estoqueNegativo,setEstoqueNegativo] = useState(false);
     const [vendaZerada,setVendaZerada] = useState(false);
     const [prodInativo,setProdInativo] = useState(false);

     const [navegar, setNavegar] = useState(false);
     const [confirmacao,setConfirmacao] = useState(false);
     const [confirmacaoId,setConfirmacaoID] = useState('');
     const [result, setResult] = useState(0);
     const [selectRelatorio, setSelectRelatorio] = useState(false);
     const [tpRelatorio, setTprelatorio] = useState(0);
     const [titulo, setTitulo] = useState('');

      function deleteUser(id){
        api.delete(vhostV1('webcash/subgrupos/'+Number(id)),config)
          .then(function (response) {
            console.log(response);
            
            setConfirmacao(false);
            setNavegar(true);
                    
          })
          .catch(function (error) {
            console.log(error);
            setConfirmacao(false);
            
          });
        
      
      }

      useEffect(function(){
        if(Number(tag) === 1){
          setTitulo('SRI Web');
        }else if(Number(tag) === 2){
          setTitulo('Catálogo Web');
        }else if(Number(tag) === 3){
          setTitulo('Auto-Atendimento');
        }else{
          setTitulo('');
        }
      },[tag])

      function handlePageChange(value){
        if(value === "&laquo;" || value === '... '){
          setnPag(1);
        }else if (value === "&lsaquo;" ){
          if (nPag !== 1){
            setnPag(nPag -1);
          }
        }else if(value === "&rsaquo;"){
          setnPag(nPag +1);        
        }else if(value === "&raquo;" || value === ' ...' ){
          setnPag(totalPaginas);        
        }else{
          setnPag(value);
        }    
       
       }

      useEffect(function(){
        setLoad(true)
        //console.log('numero de Paniga '+nPag);
        const sJson = {}
        sJson.loja=localStorage.getItem('loja'); 
        sJson.empresa=0;
        sJson.grupo=cGrupo;
        sJson.subgrupo=cSubGrupo;
        sJson.linha=cLinha;
        if(usaDcadastro === true)
        { sJson.data_cadastro=dCadastro}
        if(usaDAlteracao === true)
        { sJson.data_alteracao=dAlteracao}
        if(usaDultCompra === true)
        { sJson.data_compra=dultCompra}
        if(usaDultVenda === true)
        { sJson.data_venda=dultVenda}
        sJson.estoque_diferente=diferenteZero
        sJson.estoque_negativo=estoqueNegativo;
        sJson.preco_zerado=vendaZerada;
        sJson.inativo=false;
        sJson.pagina= nPag;
        sJson.regPag=100000;
        sJson.busca= busca; 
        sJson.tipoBusca=tpBusca;  
        sJson.tipo_prod='';                 
        
          api.post(vhostV1('webcash/produto/listar'),sJson,config)
            .then(function (response) {
              console.log(response.data.dados);           
              setProdutos(response.data.dados); 
              setSresult(response.data.result)
             
              setLoad(false);
              
                                          
                       
            })
            .catch(function (error) {
              setLoad(false);
              console.log(error);
    
                      
            });
      
            
          },[busca,nPag])


          // Função para verificar se um grupo pode ser excluído
function podeExcluirGrupo(id) {
  // Verificar se há produtos associados ao grupo
  const produtosAssociados = produtos.some(produto => produto.COD_GRUPO ===Number(id));
  console.log(produtosAssociados);
  
  
  if (produtosAssociados) {
    console.log(`Não é possível excluir o grupo com código ${id} porque existem produtos associados a ele.`);
    return false;
  }

  return true;
}

    function confirmadeleteUser(id){
      
      setConfirmacaoID(id);
      setConfirmacao(true);
      setBusca('');
      
    }

     // Aplicando a personalização com opções diferentes
// Abaixo é somente um exemplo de personalização, adapte para o seu projeto
useEffect(() => {
  // O uso do useEffect garante que a função seja chamada apenas no lado do cliente
  customizeScrollbar({
    scrollbarWidth: "10px",
    trackBackground: "#333",
    thumbBackground:
      "linear-gradient(178.8deg, #ffa066 47.41%, #ff9666 65.18%, #ff783a 90.84%)",
    thumbBorderRadius: "10px",
  });
}, []);


  let config = {
    headers: {
      'Authorization': localStorage.getItem("token")
    }
  }

  

  let config2 = {
    headers: {
      'Authorization': localStorage.getItem("token2")
    }
  }

  //buscar clientes
  useEffect(function(){
   
      api.post(vhostV1('webcash/subgrupos'),{
          pagina: nPag,
          regPag: 10,
          busca: busca,
          cod_grupo: Number(cod_grupo) 
        },config)
        .then(function (response) {
          setResult(response.data.result);
          setTotalPaginas(response.data.quantidadeDePaginas);
          setSubGrupos(response.data.dados);
          console.log(response); 
                                      
                   
        })
        .catch(function (error) {
         
          console.log(error);

                  
        });
           
        
    },[busca, nPag, cod_grupo])

 

    const getDadosRelatorio = async() => {
      let response = {};
    try {
      response = await api.post(vhostV1('webcash/grupos'), {
          pagina: 1,
          regPag: 10000,
          busca: busca
        },config)
    }
     
    catch(error) {
         
          console.log(error);

                  
        };
  return response.data.dados;
        
    }

     async function handleRelatorioGrupo() {
      if(Number(tpRelatorio) === 0){
      try {
          await gerarRelatorioGrupo();
      } catch (error) {
          console.error("Erro ao gerar relatório:", error);
      }}else{
        try {
          await gerarRelatorioGrupoDesc();
      } catch (error) {
          console.error("Erro ao gerar relatório:", error);
      }
      }
  }

  async function gerarRelatorioGrupo () { 
    
    
    const tItens = await getDadosRelatorio();
  
    
   
     GrupoProdutosPdf(tItens);
    
  
     
  }

  async function gerarRelatorioGrupoDesc () { 
    
    
    const tItens = await getDadosRelatorio();
  
    
   
    const itensOrdenados = tItens.sort((a, b) => {
        return a.DESCRICAO.localeCompare(b.DESCRICAO, 'pt-BR', { sensitivity: 'base' });
    });

    GrupoProdutosPdf(itensOrdenados);
    
  
     
  }

  
   async function handleRelatorioGrupoExcel() {
      if(Number(tpRelatorio) === 0){
      try {
          await gerarRelatorioGrupoExcel();
      } catch (error) {
          console.error("Erro ao gerar relatório:", error);
      }}else{
        try {
          await gerarRelatorioGrupoDescExcel();
      } catch (error) {
          console.error("Erro ao gerar relatório:", error);
      }
      }
  }

  async function gerarRelatorioGrupoExcel () { 
    
    
    const tItens = await getDadosRelatorio();
  
    
   
     GrupoProdutosExcel(tItens);
    
  
     
  }

  async function gerarRelatorioGrupoDescExcel () { 
    
    
    const tItens = await getDadosRelatorio();

    const itensOrdenados = tItens.sort((a, b) => {
        return a.DESCRICAO.localeCompare(b.DESCRICAO, 'pt-BR', { sensitivity: 'base' });
    });
  
    
   
     GrupoProdutosExcel(itensOrdenados);
    
  
     
  }

    useEffect(function(){
     
        api.post(vhostV1('webcash/grupos'), {
            pagina: 1,
            regPag: 100,
            busca: "",
            cod_subgrupo: 1
          },config)
          .then(function (response) {
       
            
            setGrupos(response.data.dados);
            console.log(response); 
                                        
                     
          })
          .catch(function (error) {
           
            console.log(error);
  
                    
          });
             
          
      },[])


    return <div>
        <Navbar/>
        <div className="container-fluid titulo offset-lg-1 col-lg-10">
        <h1>Cadastro de SubGrupos {`${titulo}`}</h1>
        <hr />

        <div className="row">
          <div className="col-4 mb-2 d-flex align-items-end gap-2">

  <Link 
    to='/app/novoSubGrupo/-1' 
    className="btn btn-primary btn-cli mb-3" 
    type="button"
  >
    <i className="bi bi-plus-circle-fill"></i> SubGrupo
  </Link>

  {/* <button
    id='botao-produto'
    className="btn btn-danger btn-cli"
    type="button"
    onClick={() => setSelectRelatorio(true)}
  >
    <i className="bi bi-printer-fill"></i> Relatório
  </button> */}

  <div className='mb-3'>
    <label htmlFor="inputGrupo" className="form-label">
      GRUPO
    </label>
    <select
      id="inputGrupo"
      value={cod_grupo}
      onChange={(e) => setCod_grupo(e.target.value)}
      className="form-select"
      tabIndex="3"
    >
      <option value={0}>SELECIONE</option>
      {grupos.map((grupo) => (
        <option key={grupo.COD_GRUPO} value={grupo.COD_GRUPO}>
          {grupo.COD_GRUPO} - {grupo.DESCRICAO}
        </option>
      ))}
    </select>
  </div>

</div>

          <div className="col-8">
            <div className="input-group mb-3">
              <input onChange={(e) => setTexto(e.target.value)} type="text" className="form-control" placeholder="Digite sua pesquisa" aria-describedby="button-addon2" />
              <button onClick={(e) => setBusca(texto)} className="btn btn-primary" type="button" id="button-addon2">Pesquisar</button>
            </div>
          </div>
        </div>   

         <table id='table-grupos' className="table table-hover table-striped">
            <thead>
            <tr>
                <th scope='col'>Código Grupo</th>
                <th scope='col'>Código SubGrupo</th>
                <th scope="col">Descricao</th>
                <th scope="col">Markup(%)</th>
                <th scope="col">Ações</th>
                </tr>
            </thead>
            <tbody className="table-group-divider">
              {Number(result) === 1 ?  
                 subGrupos.map((grupo)=> {
                  return <tr key={grupo.COD_SUBGRUPO}>
                      <td>{grupo.COD_GRUPO}</td>
                      <td>{grupo.COD_SUBGRUPO}</td>
                      <td>{grupo.DESCRICAO}</td>
                      <td>{grupo.MARKUP}</td>
                      <td>
                       <div id="table-prod" className="dropdown">
                        <button id='table-prod' className="btn btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                          Ações
                        </button>
                        <ul className="dropdown-menu">
                          <li>
                            <Link to={'/app/novoSubGrupo/'+grupo.COD_SUBGRUPO} className="dropdown-item">
                              <i className="bi bi-pen-fill"></i> Editar
                            </Link>
                          </li>
                          <li>
                            <button onClick={() => confirmadeleteUser(grupo.COD_SUBGRUPO)} className="dropdown-item">
                              <i className="bi bi-trash-fill"></i> Excluir
                            </button>
                          </li>
                      
                        </ul>
                      </div>
                      </td>
                  </tr>
              } ): BuscaVazaia}  
            </tbody>
          </table>

          <div className="row mt-5">
              
            <SRI_pagination totalPage={totalPaginas} 
                            page={nPag} 
                            limit={10} 
                            siblings={1}
                            onPageChange={handlePageChange}/>
            </div>

          {
           erroValidacao ? 
           <SweetAlert
              danger
              confirmBtnText="OK"
              confirmBtnBsStyle="danger"
              title="Erro"
              onConfirm={() => setErrovalidacao(false)}                            
            >
              {msgErro}
            </SweetAlert>:null
           
          }

          {
           confirmacao ? 
           <SweetAlert
              warning
              showCancel
              showCloseButton
              confirmBtnText="Sim"
              confirmBtnBsStyle="danger"
              cancelBtnText="Não"
              cancelBtnBsStyle='ligth'
              title="Atenção"
              onConfirm={() =>deleteUser(confirmacaoId)}
              onCancel={() => setConfirmacao(false)}
              focusCancelBtn
              reverseButtons
            >
              Deseja excluir Este Grupo!
            </SweetAlert>:null
           
          }

           {
                      selectRelatorio ? 
                      <SweetAlert 
                       info
                       title="Selecione o tipo de relatório!" 
                       showCloseButton
                       onConfirm={() => setSelectRelatorio(false)} 
                       onCancel={() => setSelectRelatorio(false)}
                       customButtons={
                      <React.Fragment>
                        <div className='row'>
                        <div className="d-flex justify-content-center col-12 mb-2"> 
                          <select className='form-select' onChange={(e) => setTprelatorio(e.target.value)}>
                            <option value={0}>Ordenar por Código</option>
                            <option value={1}>Ordenado por Descrição</option>
                          </select>
                        </div>
                        <div className="d-flex justify-content-end col-12">
                  <button className="btn btn-primary mr-1 btn-lg" onClick={handleRelatorioGrupo}>PDF</button>
                  <button className="btn btn-success mr-1 btn-lg" onClick={handleRelatorioGrupoExcel}>Excel</button>
                 
                  
                  </div>
                  </div>
                      </React.Fragment>
                                       }
                         >
                       
                     </SweetAlert>:null
          
          
                    }

          {navegar ? <Navigate to='/app/subgrupo' /> && window.location.reload()  : null}
     
      </div>  
      <FooterBar/>   
    </div>
}


export default SubGrupo;